
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import TextFrame from '@/components/atoms/TextFrame.vue'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'

/**
 * メッセージ表示モーダル
 */
@Component({
  components: {
    TextFrame,
    ModalWindow,
    ButtonSubmit,
  },
})
export default class ModalMessage extends Vue {
  /** モーダルウィンドウ */
  @Ref()
  modalWindow!: ModalWindow

  /** ボタン押下時イベント */
  @Prop()
  eventSubmit!: () => void

  /**
   * モーダルを開く
   */
  public show(): void {
    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }
}
